import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { AN_UNEXPECTED_ERROR, MESSAGE_TYPES, PERMISSION } from '../../../utils/constants';
import { Spin } from 'antd';
import PositionFinderExportOption from '../PositionFinderExportOption/PositionFinderExportOption';
import positionFinderApi from '../../../services/positionFinderApi';
import { PF_EXPORT_DEFAULT_SELECT_OPTIONS, PF_SORTED_OPTIONS } from '../PositionFinderExportOption/position-finder-export.constants';
import { isEmpty, uniqBy } from 'lodash';
import { pushMessage } from '../../../store/alertMessageSlice';

const PositionExport = (props) => {
  const dispatch = useDispatch();
  const { filter, keyword, role, totalData, setShowExporting } = props;
  const permissions = useSelector((state) => state.user.permissions);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedExportOptions, setSelectedExportOptions] = useState(PF_EXPORT_DEFAULT_SELECT_OPTIONS);

  const sortFilter = (selectedOptions) => {
    const orderMap = new Map(PF_SORTED_OPTIONS.map((value, index) => [value, index]));

    return [...selectedOptions]
      .sort((a, b) => {
        const indexA = orderMap.get(a.value);
        const indexB = orderMap.get(b.value);

        if (indexA === undefined && indexB === undefined) return 0;
        if (indexA === undefined) return 1;
        if (indexB === undefined) return -1;

        return indexA - indexB;
      })
      .map((o) => o.value);
  };

  const handleOnExport = async (selectedOptions) => {
    setIsLoading(true);
    try {
      const res = await positionFinderApi.requestPositionDataExport(
        {
          ...filter,
          keyword,
          export_sections: !isEmpty(selectedOptions) ? sortFilter(uniqBy(selectedOptions, 'value')) : [],
        },
        role
      );
      if (res.status === 200) {
        setShowExporting(true);
      }
    } catch (error) {
      console.error(error);
      const dataError = error?.response?.data;
      dispatch(
        pushMessage({
          message: `${dataError?.message ? dataError?.message : AN_UNEXPECTED_ERROR}`,
          type: MESSAGE_TYPES.ERROR,
          containerId: 'POSITION_FINDER_MODULE',
        })
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Spin spinning={isLoading}>
      <PositionFinderExportOption
        selectedExportOptions={selectedExportOptions}
        setSelectedExportOptions={setSelectedExportOptions}
        handleOnExport={handleOnExport}
        disabled={!permissions.includes(PERMISSION.TALENT_EXPORT) || !totalData || isLoading}
        filter={filter}
      />
    </Spin>
  );
};

export default PositionExport;
